/**
 * React component that enables copy-to-create track windows for a selected date range from an existing window.
 * @description When the component is rendered, it will be passed an existing track window, that is required. The user will then
 * pick the start date and end date. Once Copy button is clicked, new windows will be created, one for each date. 
 * All the attributes of the new windows are the same as the input window EXCEPT the window start date
 * @param Required an existing track window. 
 */
import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import moment from 'moment';

import MultiDatePicker from '@bnsf/bnsf-react-multi-date-picker';
import { DATE_FORMAT } from '../../constants/appConstants';

import './WindowCopy.css';

const WindowCopy = (props) => {
    
    const [ show, setShow ] = useState(!!props.show);
    const [ datesToCopy, setDatesToCopy ] = useState([]);

    // let datesToCopy = [];

    const handleClose = () => {
        setShow(false);
        props.onHide && props.onHide();
    }

    const handleCopy = () => { 
        // call service to copy window
        props.onCopy && props.onCopy(datesToCopy);
    }

    const getSelectedDates = (selectedDays) => {
        setDatesToCopy([...selectedDays]);

        // datesToCopy = selectedDays.map((x) => x);
    }

   

    return (
        <Modal className='clsWindowCopy' show={show}>
            <Modal.Header>
                <Modal.Title>Copy Window</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { <div className='clsDatePickerWrapper'>
            <MultiDatePicker
                theme={'darkGrey'}
                displayOnlyCalendar={true}
                numberOfMonths={1}
                maxSelectedDays={10}
                dateFormat={DATE_FORMAT}
                minDate={moment().day(moment().day() <= 2 ? 7 : 14).toDate()}
                getSelectedMultiDates={getSelectedDates} />
        </div> }
            </Modal.Body>
            <Modal.Footer>
                <Button className="btn-bwwp-secondary" onClick={handleClose}>Close</Button>
                <Button className="btn-bwwp-primary" onClick={handleCopy}>Copy</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default WindowCopy;